import { useQuery } from "@tanstack/react-query";
import { fetchSyncErrorDetails } from "src/Pages/Company/OrganizationStructure/api";

export const useFetchSyncErrorDetails = ({
  companyId,
  employeeFk,
}: {
  companyId: string;
  employeeFk: string;
}) =>
  useQuery({
    enabled: !!companyId && !!employeeFk,
    queryKey: ["sync-error-details", companyId, employeeFk],
    queryFn: () => fetchSyncErrorDetails({ companyId, employeeFk }),
  });
